/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventVirtualPageLoadedV1
 */
export interface SDKEventVirtualPageLoadedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventVirtualPageLoadedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventVirtualPageLoadedV1
     */
    person_id?: string;
}

/**
 * Check if a given object implements the SDKEventVirtualPageLoadedV1 interface.
 */
export function instanceOfSDKEventVirtualPageLoadedV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;

    return isInstance;
}

export function SDKEventVirtualPageLoadedV1FromJSON(json: any): SDKEventVirtualPageLoadedV1 {
    return SDKEventVirtualPageLoadedV1FromJSONTyped(json, false);
}

export function SDKEventVirtualPageLoadedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventVirtualPageLoadedV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
    };
}

export function SDKEventVirtualPageLoadedV1ToJSON(value?: SDKEventVirtualPageLoadedV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
        'person_id': value.person_id,
    };
}

